import { render, staticRenderFns } from "./TabletPreview.vue?vue&type=template&id=166d6425&scoped=true&"
import script from "./TabletPreview.vue?vue&type=script&lang=js&"
export * from "./TabletPreview.vue?vue&type=script&lang=js&"
import style0 from "./TabletPreview.vue?vue&type=style&index=0&id=166d6425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d6425",
  null
  
)

export default component.exports